'use strict';

/*
Example:
    <chosen-component value="data.value" type="interest" placeholder="" ng-event="change: onChange()"></chosen-component>
*/

var util = angular.module('gymsystem.util');

util.directive('chosenComponent', ['$http', '$rootScope', '$timeout', '$parse', '$filter', 'Data', function($http, $rootScope, $timeout, $parse, $filter, Data) {
    return {
        scope: {},
        restrict: 'AE',
        template: '<select ng-disabled="disabled" multiple class="form-control"><option ng-repeat="it in list" value="{{it.id}}">{{it.name | translate}}</option></select>',
        link: function($scope, $element, $attrs) {
            var selectElement = $($element[0].childNodes[0]);
            var placeholder = ' ';
            if($attrs.placeholder == null) {
                placeholder = $filter('translate')('Select');
            } else if($attrs.placeholder) {
                placeholder = $filter('translate')($attrs.placeholder);
            }
            $scope.disabled = $attrs.disabled && $parse($attrs.disabled)($scope.$parent);

            selectElement.chosen({
                placeholder_text_multiple: placeholder,
                width: '100%'
            });
            var getter = $parse($attrs.value);
            var setter = getter.assign;

            function rebuild() {
                $timeout(function() {
                    var value = getter($scope.$parent) || [];
                    selectElement.children().each(function(_, option) {
                        if(value.indexOf(Number(option.value)) >= 0) {
                            option.selected = true;
                        }
                    });
                    selectElement.trigger("chosen:updated");
                }, 0);
            }

            $scope.list = [];
            var type = $attrs.type;
            if(type === 'role') {
                $scope.list = $rootScope.roles;
            } else if(type === 'interest') {
                Data.load('interest').then(function(result) {
                    $scope.list = result;
                    rebuild();
                });
            }

            selectElement.on('change', function() {
                var value = selectElement.val();
                if(!value) {
                    value = [];
                }
                value = value.map(Number);
                setter($scope.$parent, value);
                $scope.$apply();

                $element[0].dispatchEvent(new CustomEvent('change'));
            });

            rebuild();
            $scope.$on('$destroy', function () {
                selectElement.chosen("destroy");
            });
        }
    };
}]);
